export const DEFAULT_VARIANT = "dialog";
export const DEFAULT_FIELD_LABEL = "Upload file";
export const DEFAULT_ACCEPTED_TYPES = ["pdf"];

export const getSupportedTypesText = (allowedFileTypes) => {
  const formats = allowedFileTypes.map(format => format.toUpperCase()).join(", ");
  return `Supported formats: ${formats.length > 30 ? formats.slice(0, 30) + "..." : formats}`;
};

export const ERROR_TYPE = {
  INVALID_TYPE: "file-invalid-type",
  DUPLICATE_FILE: "file-duplicate"
};

export const ERROR_MESSAGES = {
  UPLOAD_FAILED: "Failed to upload file",
  SAS_URLS_FAILED: "Failed to get SAS URLs for all files",
  UNSUPPORTED_FORMAT: (acceptedTypes) => `Unsupported file format. Please upload a ${acceptedTypes.join(", ")} file`,
  DUPLICATE_FILE: (files) => files.length > 1 ? "Some files have already been uploaded" : "This file has already been uploaded"
};

export const BUTTON_TEXT = {
  DOWNLOAD: "Download"
};

export const PROGRESS_MODE = {
  REPLACE: "replace",
  MERGE: "merge"
};

export const PROGRESS = {
  STARTED: 0,
  ENDED: 100
};
